//Fundamentals
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { PersistGate } from 'redux-persist/integration/react';

//Visuals
import './index.css';

//Redux
import { Provider } from "react-redux";
import { store, persistor } from './js/store/index';


ReactDOM.render(
<Provider store={store}>
  <PersistGate loading={null} persistor={persistor}>
    <App />
  </PersistGate>
</Provider>, document.getElementById('root'));
